import { SwadeshDisplayCardProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<SwadeshDisplayCardProps>
  ): React.FC<SwadeshDisplayCardProps> =>
  (props: SwadeshDisplayCardProps) => {
    return <Component {...props} />;
  };
